import { ContractDto } from "@custom-types/contract"
import ContractLabel from "@features/administration/contracts/SelectContract/ContractLabel"
import ContractTooltip from "@features/administration/contracts/SelectContract/ContractTooltip"
import { getAvailableContracts } from "@features/administration/users/UserForm/const"
import { Box, MenuItem, Select, SelectProps } from "@mui/material"
import { GridRowId, useGridApiContext } from "@mui/x-data-grid"
import { useLayoutEffect, useRef } from "react"

type SelectContractProps = SelectProps & {
  contracts: ContractDto[]
  value: string
  hasFocus?: boolean
  field: string
  gridRowId: GridRowId
}

const SelectContract = ({
  contracts,
  value,
  hasFocus,
  field,
  gridRowId,
  ...props
}: SelectContractProps) => {
  const ref = useRef<HTMLInputElement>()
  const apiRef = useGridApiContext()
  const availableContracts = getAvailableContracts(contracts, apiRef.current, gridRowId)

  useLayoutEffect(() => {
    if (hasFocus) ref?.current?.focus()
  }, [hasFocus])

  return (
    <Select
      fullWidth
      value={value}
      ref={ref}
      renderValue={() => <ContractLabel contractKey={value} />}
      onChange={({ target: { value } }) => {
        apiRef.current.setEditCellValue({ id: gridRowId, field, value })
      }}
      {...props}
    >
      {availableContracts.map(({ contract, isUsed }) => (
        <MenuItem key={contract.key} value={contract.key} disabled={isUsed}>
          <ContractTooltip contract={contract}>
            <Box sx={{ width: "100%" }}>
              <ContractLabel contractKey={contract.key} />
            </Box>
          </ContractTooltip>
        </MenuItem>
      ))}
    </Select>
  )
}

export default SelectContract
